import Custom from "../../../Components/Buttons/Custom";

export default function NotifModal({ onClose, title, infoText}) {

  return (
    <div className="p-5 w-full max-w-sm max-h-[70dvh] rounded-2xl flex flex-col gap-6 bg-zi-bg2-light dark:bg-zi-bg2-dark drop-shadow-lg">
      <div className="w-full flex items-center justify-between gap-1">
        <h5 className="font-medium text-base sm:text-xl text-zi-text-light dark:text-zi-text-dark overflow-hidden whitespace-nowrap text-ellipsis">
          {title}
        </h5>
      </div>

      <div className="w-full min-w-0 flex items-center gap-1 sm:gap-5 text-justify text-sm sm:text-base !leading-relaxed overflow-y-auto">
        <p className="flex-1 min-w-0 text-zi-text-light dark:text-zi-text-dark">
          {infoText}
        </p>
      </div>

      <div onClick={onClose}>
        <Custom
          text="بستن"
          className="bg-zi-buttonbg-primary mt-6 text-zi-text-dark w-full hocus:opacity-85"
        />
      </div>
    </div>
  );
}
